// hooks/useQueryParam.js
import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
export function useQueryParam(key, initial) {
  const [sp, setSp] = useSearchParams();
  const value = sp.get(key) ?? initial ?? null;

  const setValue = useCallback((v) => {
    // 항상 현재 URL을 기준으로 새로 복사
    const next = new URLSearchParams(window.location.search);
    if (v === null || v === undefined || v === '') next.delete(key);
    else next.set(key, String(v)); // ← 문자열로 강제
    setSp(next, { replace: true });
  }, [key, setSp]);
  
  return [value, setValue];
}